// app/redux/actions/workDaysActions.js

// ------------------- TYPES -------------------
export const SET_WORKDAYS_LOADING = "SET_WORKDAYS_LOADING";
export const SET_WORKDAYS_ERROR = "SET_WORKDAYS_ERROR";

// Workdays
export const GET_WORKDAYS_CONFIG_REQUEST = "GET_WORKDAYS_CONFIG_REQUEST";
export const GET_WORKDAYS_CONFIG_SUCCESS = "GET_WORKDAYS_CONFIG_SUCCESS";
export const GET_WORKDAYS_CONFIG_FAIL = "GET_WORKDAYS_CONFIG_FAIL";

export const UPDATE_WORKDAYS_CONFIG_REQUEST = "UPDATE_WORKDAYS_CONFIG_REQUEST";
export const UPDATE_WORKDAYS_CONFIG_SUCCESS = "UPDATE_WORKDAYS_CONFIG_SUCCESS";
export const UPDATE_WORKDAYS_CONFIG_FAIL = "UPDATE_WORKDAYS_CONFIG_FAIL";

// Holiday settings (FIXED/HIJRI/CUSTOM)
export const GET_CALENDAR_SETTINGS_REQUEST = "GET_CALENDAR_SETTINGS_REQUEST";
export const GET_CALENDAR_SETTINGS_SUCCESS = "GET_CALENDAR_SETTINGS_SUCCESS";
export const GET_CALENDAR_SETTINGS_FAIL = "GET_CALENDAR_SETTINGS_FAIL";

export const UPDATE_CALENDAR_SETTINGS_REQUEST = "UPDATE_CALENDAR_SETTINGS_REQUEST";
export const UPDATE_CALENDAR_SETTINGS_SUCCESS = "UPDATE_CALENDAR_SETTINGS_SUCCESS";
export const UPDATE_CALENDAR_SETTINGS_FAIL = "UPDATE_CALENDAR_SETTINGS_FAIL";

// ------------------- ACTIONS -------------------
export const setWorkDaysLoading = (value) => ({ type: SET_WORKDAYS_LOADING, payload: !!value });
export const setWorkDaysError = (msg) => ({ type: SET_WORKDAYS_ERROR, payload: msg || null });

// Workdays
export const getWorkdaysConfigRequest = () => ({ type: GET_WORKDAYS_CONFIG_REQUEST });
export const getWorkdaysConfigSuccess = (data) => ({ type: GET_WORKDAYS_CONFIG_SUCCESS, payload: data });
export const getWorkdaysConfigFail = (err) => ({ type: GET_WORKDAYS_CONFIG_FAIL, payload: err });

export const updateWorkdaysConfigRequest = (data) => ({ type: UPDATE_WORKDAYS_CONFIG_REQUEST, payload: data });
export const updateWorkdaysConfigSuccess = (data) => ({ type: UPDATE_WORKDAYS_CONFIG_SUCCESS, payload: data });
export const updateWorkdaysConfigFail = (err) => ({ type: UPDATE_WORKDAYS_CONFIG_FAIL, payload: err });

// Calendar Settings
export const getCalendarSettingsRequest = (year, country = "MA") => ({
    type: GET_CALENDAR_SETTINGS_REQUEST,
    payload: { year, country },
});
export const getCalendarSettingsSuccess = (data) => ({ type: GET_CALENDAR_SETTINGS_SUCCESS, payload: data });
export const getCalendarSettingsFail = (err) => ({ type: GET_CALENDAR_SETTINGS_FAIL, payload: err });

export const updateCalendarSettingsRequest = (year, country = "MA", data) => ({
    type: UPDATE_CALENDAR_SETTINGS_REQUEST,
    payload: { year, country, data },
});
export const updateCalendarSettingsSuccess = (data) => ({ type: UPDATE_CALENDAR_SETTINGS_SUCCESS, payload: data });
export const updateCalendarSettingsFail = (err) => ({ type: UPDATE_CALENDAR_SETTINGS_FAIL, payload: err });
